import React, { useState } from "react";
import {
  Modal,
  Row,
  Col,
  Button,
  Space,
  message,
  Spin,
  Tag,
  Empty,
  Alert,
} from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import {
  create_cc2h,
  main_wcch_ceo,
  HEADERS_BASIC90,
} from "../api/apiCent90";

function ModalAccept({ dataA, selectedRowKeys, onSuccess, disabled }) {
  const [isModalOpenSentS4, setIsModalOpenSentS4] = useState(false);
  const [loading, setLoading] = useState(false); // ✅ เพิ่ม
  const [checkingS2, setCheckingS2] = useState(false); // ✅ loading ตอนเช็ค checkS2
  const [checkS2Data, setCheckS2Data] = useState([]); // ✅ ผลลัพธ์จาก checkS2 ใช้เช็คว่ามีข้อมูลค้างไหม
  const user = localStorage.getItem("USERNAME");
  console.log("data124", dataA);

  const STEP_AR = 1; // เร่งรัดส่งหา CEO (ค่าตายตัว ไม่ต้องเลือก)

  // ยึดวันนี้เป็นหลัก: วันเริ่มต้น = วันนี้ - 30 วัน, วันสิ้นสุด = วันนี้ + 30 วัน
  const dateSt = dayjs().subtract(30, "day").format("YYYY-MM-DD");
  const dateEnd = dayjs().add(30, "day").format("YYYY-MM-DD");

  //เปิด Modal
  const handleOpenS4 = () => {
    setIsModalOpenSentS4(true);
    checkS2(); // ✅ เช็คข้อมูลค้างทุกครั้งที่เปิด modal
  };
  //ปิด Modal
  const handleCloseS4 = () => {
    setIsModalOpenSentS4(false);
    //close(false);
  };
  //ปิด พิมพ์เอกสาร
  const printPDFS4 = () => {
    if (dataA) {
      loadData();
      // setIsModalOpenSentS4(false);
    }
  };
  const loadData = async () => {
    setLoading(true); // ✅ เริ่ม loading
    try {
      // ✅ map แต่ละ record เป็น object ธรรมดา ไม่ต้องห่อ data ซ้อนใน loop
      const dataArr = dataA.map((item) => ({
        CONTNO: item.contno,
        DATA_TYPE: item.dataType,
        wdrId: item.wdrId,
        caseType: item.caseType,
        roundDate: item.roundDate,
      }));

      // ✅ ห่อรวม user + data เข้าด้วยกันเป็น payload สุดท้าย
      const payload = {
        user: user,
        data: dataArr,
      };

      const res = await axios.post(
        create_cc2h,
        payload, // ✅ ส่งเป็น array
        {
          headers: HEADERS_BASIC90,
        },
      );
      console.log(res);
      message.success("บันทึกสำเร็จ");
      setIsModalOpenSentS4(false); // ✅ ปิด Modal หลังสำเร็จ
      if (onSuccess) onSuccess(); // ✅ เรียก reload ตาราง
    } catch (err) {
      console.log(err);
      message.error("บันทึกไม่สำเร็จ");
    } finally {
      setLoading(false); // ✅ หยุด loading ไม่ว่าจะสำเร็จหรือไม่
    }
  };

  // ✅ เช็คว่ามีข้อมูลค้างอยู่ในสถานะ S2 (เร่งรัดส่งหา CEO) หรือไม่
  // ถ้าเจอข้อมูล (checkS2Data.length > 0) จะไปบล็อกปุ่ม "ยืนยัน" ด้านล่าง
  const checkS2 = async () => {
    setCheckingS2(true);
    try {
      const res = await axios.post(
        main_wcch_ceo,
        {
          day1: dateSt,
          day2: dateEnd,
          numberPage: 1,
          pageSize: 100,
          keyword: "",
          status: STEP_AR,
          role: "3",
          idCompany: 1,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic dXNlcnMtbGF3eWVyOm9uZWxlYXNpbmc=",
          },
        },
      );
      console.log("res.data", res.data);
      const dataB = res.data.Main || [];
      setCheckS2Data(dataB);
    } catch (err) {
      console.log(err);
    } finally {
      setCheckingS2(false);
    }
  };

  const hasSelection = dataA && dataA.length > 0;
  const hasConflict = checkS2Data.length > 0; // ✅ true ถ้ามีข้อมูลค้าง ต้องบล็อกปุ่มยืนยัน

  // ✅ เกินรอบการส่งไปแล้วหรือยัง: วันนี้ > roundDate (เลยวันรอบไปแล้ว ไม่ใช่แค่ถึงรอบ)
  const isPastRound = (item) => {
    if (!item || !item.roundDate) return false;
    return dayjs()
      .startOf("day")
      .isAfter(dayjs(item.roundDate).startOf("day"));
  };

  // ✅ true เมื่อทุกสัญญาที่เลือกเลยรอบการส่งไปแล้ว -> ให้ยืนยันได้แม้มีข้อมูล CEO ค้าง
  const pastRound = hasSelection && dataA.every(isPastRound);

  // ✅ บล็อกเพราะข้อมูลค้างเฉพาะกรณีที่ยัง "ไม่เกินรอบการส่ง"
  const blockByConflict = hasConflict && !pastRound;

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <Modal
        title="ยืนยันรับเคส เพื่อออกจดหมายบอกเลิก"
        open={isModalOpenSentS4}
        onCancel={handleCloseS4}
        width={"80%"}
        footer={null}
        maskClosable={false}
      >
        <Spin spinning={loading || checkingS2} tip="กำลังตรวจสอบ...">
          <Row>
            {/* หัวข้อจำนวนสัญญา เน้นตัวเลขให้เด่น พร้อม icon */}
            <Col span={24}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  background: "#f0f9ff",
                  border: "1px solid #91d5ff",
                  borderRadius: "8px",
                  padding: "16px 20px",
                  margin: "16px 0",
                }}
              >
                <CheckCircleOutlined
                  style={{ fontSize: "28px", color: "#1677ff" }}
                />
                <div>
                  <div style={{ fontSize: "13px", color: "#8c8c8c" }}>
                    กำลังจะยืนยันรับเคส
                  </div>
                  <div style={{ fontSize: "22px", fontWeight: 600 }}>
                    {dataA.length} สัญญา
                  </div>
                </div>
              </div>
            </Col>

            {/* คำเตือนถ้าเจอข้อมูลค้างจาก checkS2 (บล็อกเฉพาะกรณียังไม่เกินรอบการส่ง) */}
            {blockByConflict && (
              <Col span={24} style={{ marginBottom: "16px" }}>
                <Alert
                  type="warning"
                  showIcon
                  message={`พบข้อมูลที่ CEO ยังไม่อนุมัติเคสค้างอยู่ในระบบ ${checkS2Data.length} รายการ ไม่สามารถยืนยันรับเคสได้ในขณะนี้`}
                />
              </Col>
            )}

            {/* เกินรอบการส่งไปแล้ว: มีข้อมูลค้างแต่อนุญาตให้ยืนยันได้ */}
            {hasConflict && pastRound && (
              <Col span={24} style={{ marginBottom: "16px" }}>
                <Alert
                  type="info"
                  showIcon
                  message={`พบข้อมูลที่ CEO ยังไม่อนุมัติเคสค้างอยู่ในระบบ ${checkS2Data.length} รายการ แต่เลยรอบการส่งแล้ว จึงสามารถยืนยันรับเคสได้`}
                />
              </Col>
            )}

            {/* รายการเลขสัญญา แสดงเป็น Tag อ่านง่ายกว่าสตริงคั่น || */}
            <Col span={24} style={{ marginBottom: "16px" }}>
              {hasSelection ? (
                <div
                  style={{
                    border: "1px solid #f0f0f0",
                    borderRadius: "8px",
                    padding: "12px",
                    maxHeight: "220px",
                    overflowY: "auto",
                  }}
                >
                  <Space size={[8, 8]} wrap>
                    {selectedRowKeys.map((key) => (
                      <Tag key={key} color="blue">
                        {key}
                      </Tag>
                    ))}
                  </Space>
                </div>
              ) : (
                <Empty description="ยังไม่ได้เลือกสัญญา" />
              )}
            </Col>

            <Col span={24} style={{ textAlign: "right" }}>
              <Space>
                <Button
                  type="primary"
                  htmlType="button"
                  onClick={printPDFS4}
                  loading={loading} // ✅ ปุ่มแสดง loading
                  disabled={
                    loading || checkingS2 || !hasSelection || blockByConflict
                  }
                >
                  ยืนยัน
                </Button>
                <Button
                  onClick={handleCloseS4}
                  disabled={loading} // ✅ กดยกเลิกไม่ได้ตอนโหลด
                >
                  ยกเลิก
                </Button>
              </Space>
            </Col>
          </Row>
        </Spin>
      </Modal>
      <Button
        color="cyan"
        variant="solid"
        onClick={handleOpenS4}
        disabled={disabled}
        title={disabled ? "ยังไม่ถึงรอบการส่ง" : undefined}
      >
        ยืนยันรับเคส
      </Button>
    </div>
  );
}
export default ModalAccept;